<div class="mx-auto flex w-full min-w-0 max-w-[70rem] flex-col bg-card px-4 py-6 sm:px-6">
  <div class="flex flex-col w-full justify-center h-full">


    <div class="flex flex-row ">
      <i class="fa fa-arrow-right icon-size-6 mr-2 self-center text-primary"></i>
      <span class="font-bold text-3xl">
        Nový náběrový list
      </span>
    </div>


    <div
      class="grid w-full grid-cols-[repeat(auto-fit,minmax(min(100%,14rem),1fr))] gap-4 py-4"
      >

      <!-- Byt na prodej -->
      <div (click)="redirectTo('flat-form')" id="flat-sale-card"
                 class="w-full h-72 p-4 bg-[#F3F3F3] hover-gradient-primary
            rounded-[20px] transition duration-700 ease-in-out cursor-pointer border border-[#E9E9E9]
            text-2xl font-semibold flex flex-col items-start justify-between group">
        <!-- Top Left Image -->
        <div class="flex items-center mb-4">
          <div
            class="w-16 h-16 rounded-full flex items-center justify-center mr-3 border border-primary overflow-hidden relative">
            <!-- GIF -->
            <img src="assets/images/sting/gifs/building.gif"
              class="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out">
              <!-- Static Image -->
              <img src="assets/images/sting/icons/flat.svg"
                class="absolute inset-0 w-[88%] h-[88%] m-auto opacity-100 group-hover:opacity-0 transition-opacity duration-700 ease-in-out">
              </div>
            </div>
            <!-- Title and Subtitle -->
            <div>
              <div
                class="text-3xl font-semibold mb-2 text-[#1A1A1A]">{{ 'building_type.items.flat_for_sale'|translate }}
              </div>
              <div
                class="text-md text-[#1A1A1A] mb-4 font-normal">{{ 'building_type.items.flat_for_sale_subtitle'|translate }}
              </div>
            </div>
            <!-- Bottom Right Button with Right Arrow -->
            <div class="flex justify-end w-full">
              <button mat-icon-button class="bg-black text-white">
                <i class="fal fa-arrow-right icon-size-5"></i>
              </button>
            </div>
          </div>

          <!-- Byt k pronájmu -->
          <div (click)="redirectTo('flat-rent-form')"
                 class="w-full h-72 p-4 bg-[#F3F3F3] hover-gradient-primary
                rounded-[20px] transition duration-700 ease-in-out cursor-pointer border border-[#E9E9E9]
                text-2xl font-semibold flex flex-col items-start justify-between group">
            <!-- Top Left Image -->
            <div class="flex items-center mb-4">
              <div
                class="w-16 h-16 rounded-full flex items-center justify-center mr-3 border border-primary overflow-hidden relative">
                <!-- GIF -->
                <img src="assets/images/sting/gifs/lease.gif"
                  class="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out">
                  <!-- Static Image -->
                  <img src="assets/images/sting/icons/flat-rent.svg"
                    class="absolute inset-0 w-[70%] h-[70%] m-auto opacity-100 group-hover:opacity-0 transition-opacity duration-700 ease-in-out">
                  </div>
                </div>
                <!-- Title and Subtitle -->
                <div>
                  <div
                    class="text-3xl font-semibold mb-2 text-[#1A1A1A]">{{ 'building_type.items.flat_for_rent' | translate }}
                  </div>
                  <div
                    class="text-md text-[#1A1A1A] mb-4 font-normal">{{ 'building_type.items.flat_for_rent_subtitle' | translate }}
                  </div>
                </div>
                <!-- Bottom Right Button with Right Arrow -->
                <div class="flex justify-end w-full">
                  <button mat-icon-button class="bg-black text-white">
                    <i class="fal fa-arrow-right icon-size-5"></i>
                  </button>
                </div>
              </div>

              <!-- Rodinný dům -->
              <div (click)="redirectTo('status-record-form')"
                 class="w-full h-72 p-4 bg-[#F3F3F3] hover-gradient-primary
                rounded-[20px] transition duration-700 ease-in-out cursor-pointer border border-[#E9E9E9]
                text-2xl font-semibold flex flex-col items-start justify-between group">
                <!-- Top Left Image -->
                <div class="flex items-center mb-4">
                  <div
                    class="w-16 h-16 rounded-full flex items-center justify-center mr-3 border border-primary overflow-hidden relative">
                    <!-- GIF -->
                    <img src="assets/images/sting/gifs/house.gif"
                      class="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out">
                      <!-- Static Image -->
                      <img src="assets/images/sting/icons/building.svg"
                        class="absolute inset-0 w-[70%] h-[70%] m-auto opacity-100 group-hover:opacity-0 transition-opacity duration-700 ease-in-out">
                      </div>
                    </div>
                    <!-- Title and Subtitle -->
                    <div>
                      <div
                        class="text-3xl font-semibold mb-2 text-[#1A1A1A]">{{ 'building_type.items.house_for_sale' | translate }}
                      </div>
                      <div
                        class="text-md text-[#1A1A1A] mb-4 font-normal">{{ 'building_type.items.house_for_sale_subtitle' | translate }}
                      </div>
                    </div>
                    <!-- Bottom Right Button with Right Arrow -->
                    <div class="flex justify-end w-full">
                      <button mat-icon-button class="bg-black text-white">
                        <i class="fal fa-arrow-right icon-size-5"></i>
                      </button>
                    </div>
                  </div>

                  <!-- Pozemek -->
                  <div (click)="redirectTo('area-form')"
                 class="w-full h-72 p-4 bg-[#F3F3F3] hover-gradient-primary
                rounded-[20px] transition duration-700 ease-in-out cursor-pointer border border-[#E9E9E9]
                text-2xl font-semibold flex flex-col items-start justify-between group">
                    <!-- Top Left Image -->
                    <div class="flex items-center mb-4">
                      <div
                        class="w-16 h-16 rounded-full flex items-center justify-center mr-3 border border-primary overflow-hidden relative">
                        <!-- GIF -->
                        <img src="assets/images/sting/gifs/fence.gif"
                          class="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out">
                          <!-- Static Image -->
                          <img src="assets/images/sting/icons/area.svg"
                            class="absolute inset-0 w-[80%] h-[80%] m-auto opacity-100 group-hover:opacity-0 transition-opacity duration-700 ease-in-out">
                          </div>
                        </div>
                        <!-- Title and Subtitle -->
                        <div>
                          <div
                            class="text-3xl font-semibold mb-2 text-[#1A1A1A]">{{ 'building_type.items.area_for_sale' | translate }}
                          </div>
                          <div
                            class="text-md text-[#1A1A1A] mb-4 font-normal">{{ 'building_type.items.area_for_sale_subtitle' | translate }}
                          </div>
                        </div>
                        <!-- Bottom Right Button with Right Arrow -->
                        <div class="flex justify-end w-full">
                          <button mat-icon-button class="bg-black text-white">
                            <i class="fal fa-arrow-right icon-size-5"></i>
                          </button>
                        </div>
                      </div>

                      <!-- Jiná stavba -->
                      @if (flagService.isEnabled$('ff_form_other_type') | async) {
                        <div (click)="redirectTo('others-form')"
                 class="w-full h-72 p-4 bg-[#F3F3F3] hover-gradient-primary
                rounded-[20px] transition duration-700 ease-in-out cursor-pointer border border-[#E9E9E9]
                text-2xl font-semibold flex flex-col items-start justify-between group">
                          <!-- Top Left Image -->
                          <div class="flex items-center mb-4">
                            <div
                              class="w-16 h-16 rounded-full flex items-center justify-center mr-3 border border-primary overflow-hidden relative">
                              <!-- GIF -->
                              <img src="assets/images/sting/gifs/fence.gif"
                                class="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out">
                                <!-- Static Image -->
                                <img src="assets/images/sting/icons/area.svg"
                                  class="absolute inset-0 w-[80%] h-[80%] m-auto opacity-100 group-hover:opacity-0 transition-opacity duration-700 ease-in-out">
                                </div>
                              </div>
                              <!-- Title and Subtitle -->
                              <div>
                                <div
                                  class="text-3xl font-semibold mb-2 text-[#1A1A1A]">{{ 'building_type.items.others_for_sale' | translate }}
                                </div>
                                <div
                                  class="text-md text-[#1A1A1A] mb-4 font-normal">{{ 'building_type.items.others_for_sale_subtitle' | translate }}
                                </div>
                              </div>
                              <!-- Bottom Right Button with Right Arrow -->
                              <div class="flex justify-end w-full">
                                <button mat-icon-button class="bg-black text-white">
                                  <i class="fal fa-arrow-right icon-size-5"></i>
                                </button>
                              </div>
                            </div>
                          }

                        </div>


                      </div>


                      <div class="flex flex-col w-full justify-center h-full">

                        <div class="flex flex-row ">
                          <i class="fa fa-arrow-right icon-size-6 mr-2 self-center text-primary"></i>
                          <span class="font-bold text-3xl">
                            Přehled náběrových listů
                          </span>
                        </div>


                        <div class="flex w-full py-4">

                          <div (click)="redirectTo('forms')" id="forms-card"
                 class="w-full max-w-[24rem] h-64 p-4 bg-[#F3F3F3] hover-gradient-primary
               rounded-[20px] transition duration-700 ease-in-out cursor-pointer border border-[#E9E9E9]
               text-2xl font-semibold flex flex-col items-start justify-between group">

                            <!-- Top Left Image -->
                            <div class="flex items-center mb-4">
                    <div class="w-16 h-16 rounded-full flex items-center transition duration-700 ease-in-out
                    justify-center mr-3 border border-primary overflow-hidden relative group-hover:bg-white">
                                <!-- Static Image -->
                                <img src="assets/images/sting/icons/sign.svg"
                                  class="absolute inset-0 w-[70%] h-[70%] m-auto transition-opacity duration-700 ease-in-out">
                                </div>
                              </div>
                              <!-- Title -->
                              <div>
                                <div class="text-3xl font-semibold mb-2 text-[#1A1A1A]">{{ 'building_type.history' | translate }}
                                </div>
                                <div class="text-md text-[#1A1A1A] mb-4 font-normal">

                                  <div class="mt-2 font-medium text-fuse-secondary">
                                    @if (formsCount >= 0) {
                                      {{ formsCount }}
                                    }
                                    {{
                                    formsCount
                                    | i18nPlural
                                    : {
                                    "=0": translateService.instant("section.building_type.history_0"),
                                    "=1": translateService.instant("section.building_type.history_1"),
                                    "=2": translateService.instant("section.building_type.history_2"),
                                    "=3": translateService.instant("section.building_type.history_3"),
                                    "=4": translateService.instant("section.building_type.history_4"),
                                    other: translateService.instant("section.building_type.history_other"),
                                  }
                                  }}
                                </div>
                              </div>
                            </div>

                            <!-- Bottom Right Button with Right Arrow -->
                            <div class="flex justify-end w-full">
                              <button mat-icon-button class="bg-black text-white">
                                <i class="fal fa-arrow-right icon-size-5"></i>
                              </button>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>
